import {
  normalize,
  upgrade,
  validate
} from "@scalar/openapi-parser";
import { bundle } from "@scalar/json-magic/bundle";
import { fetchUrls } from "@scalar/json-magic/bundle/plugins/browser";
function createEmptySpec() {
  return {
    openapi: "3.1.0",
    info: {
      title: "",
      version: ""
    },
    paths: {}
  };
}
async function parseDocument(document, opts) {
  try {
    const normalized = normalize(document);
    const upgraded = upgrade(normalized);
    const bundled = await bundle(upgraded.specification, {
      plugins: [fetchUrls()],
      treeShake: true
    });
    if (opts?.validate) {
      const validated = await validate(bundled);
      return {
        errors: validated.errors || [],
        valid: validated.valid,
        spec: bundled
      };
    }
    return {
      errors: [],
      valid: true,
      spec: bundled
    };
  } catch {
    return {
      errors: [
        {
          code: "invalid-document",
          message: "Failed to parse the OpenAPI document. It might be invalid?"
        }
      ],
      valid: false,
      spec: createEmptySpec()
    };
  }
}
export {
  createEmptySpec,
  parseDocument
};
//# sourceMappingURL=openapi.js.map
